function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { classNamesFor } from '../utils/classNames';
var cx;
/**
 * **Deprecated** Use layer classes directly to position AlertBubble component.
 *
 * The Alert component provides layout for AlertIndicators / Bubbles. It supports two
 * alerts.
 *
 * [Mobile Design System Avatars](https://confluence.sie.sony.com/display/PPRC1/1-0Prod_Avatars)
 * [Mobile Design System Quick Actions](https://confluence.sie.sony.com/pages/viewpage.action?spaceKey=PPRC1&title=1-0Prod_Quick+Actions)
 *
 * ## Related Components
 * - [Button](../Button/README.md)
 * - [AvatarIcon](../AvatarIcon/README.md)
 * - [Icon](../Icon/README.md)
 *
 * ## Usage
 *
 * Alerts without text.
 *
 * ```jsx
 * <Alert
 *  className="my-class"
 *  alert1
 *  alert2
 * >
 *  <AvatarIcon
 *    size="small"
 *    src="http://profilePicOrAvatar/image.webp"
 *    alt="So and so's image"
 *    withAlert
 *  />
 * </Alert>
 * ```
 *
 * Alerts with text.
 *
 * ```jsx
 * <Alert
 *  className="my-class"
 *  alert1Text="100"
 *  alert2Text="100"
 * >
 *  <AvatarIcon
 *    size="small"
 *    src="http://profilePicOrAvatar/image.webp"
 *    alt="So and so's image"
 *    withAlert
 *  />
 * </Alert>
 * ```
 *
 * ## Style Hooks
 *
 * This component has the following style hooks:
 * - **root** the component root element
 * - **alert1** the top alert
 * - **alert2** the bottom alert
 *
 * ## Props
 */

var Alert = /*#__PURE__*/function (_PureComponent) {
  _inherits(Alert, _PureComponent);

  var _super = _createSuper(Alert);

  function Alert() {
    _classCallCheck(this, Alert);

    return _super.apply(this, arguments);
  }

  _createClass(Alert, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          className = _this$props.className,
          alert1 = _this$props.alert1,
          alert1Text = _this$props.alert1Text,
          alert2 = _this$props.alert2,
          alert2Text = _this$props.alert2Text,
          children = _this$props.children;

      var _Alert$getClassName = Alert.getClassName({
        className: className,
        alert1Text: alert1Text,
        alert2Text: alert2Text
      }),
          root = _Alert$getClassName.root,
          alert1Class = _Alert$getClassName.alert1,
          alert2Class = _Alert$getClassName.alert2;

      return /*#__PURE__*/React.createElement("span", {
        "data-qa": qa,
        className: root
      }, children, (alert1 || alert1Text) && /*#__PURE__*/React.createElement("span", {
        "data-qa": "".concat(qa, "#alert1"),
        className: alert1Class
      }, alert1Text), (alert2 || alert2Text) && /*#__PURE__*/React.createElement("span", {
        "data-qa": "".concat(qa, "#alert2"),
        className: alert2Class
      }, alert2Text));
    }
  }]);

  return Alert;
}(PureComponent);

Alert.defaultProps = {
  qa: '',
  className: '',
  alert1: false,
  alert2: false,
  alert1Text: '',
  alert2Text: '',
  children: null
};
Alert.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * Whether to display the top-most alert dot
   */
  alert1: PropTypes.bool,

  /**
   * Whether to display the bottom-most alert dot
   */
  alert2: PropTypes.bool,

  /**
   * Whether to display the top-most alert with text (e.g. notification count)
   */
  alert1Text: PropTypes.string,

  /**
   * Whether to display the bottom-most alert with text (e.g. notification count)
   */
  alert2Text: PropTypes.string,

  /**
   * Component to display alerts on top of.
   */
  children: PropTypes.node
};
/**
 * Gets the classNames attached to the style hooks for this component.
 * @returns {string} the aliased classNames for Alert
 */

Alert.getClassName = function (_ref) {
  var className = _ref.className,
      alert1Text = _ref.alert1Text,
      alert2Text = _ref.alert2Text;

  var makeAlertClasses = function makeAlertClasses(hasAlertText) {
    return cx('psw-body-3', 'psw-text-bold', 'psw-alert-indicator', 'psw-round-rect', "psw-origin-".concat(hasAlertText ? 'inner' : 'center'), _defineProperty({}, cx('psw-alert-indicator-only'), !hasAlertText), _defineProperty({}, cx('psw-alert-indicator-with-text', 'psw-p-x-xs', 'psw-p-y-3xs'), hasAlertText));
  };

  return {
    root: cx('psw-alert', 'psw-l-inline', 'psw-l-anchor', 'psw-l-shrink-wrap', className),
    alert1: cx('psw-alert-indicator-1', makeAlertClasses(alert1Text), 'psw-top-right-circle'),
    alert2: cx('psw-alert-indicator-2', makeAlertClasses(alert2Text), 'psw-bottom-right-circle')
  };
};
/**
 * Defines aliases for classNames used by this component
 */


Alert.useClassNames = function (classNames) {
  Alert.classNames = classNames;
};

cx = classNamesFor(Alert);
export default Alert;